import defaultInstance from './defaultInstance'
import pureInstance from './pureInstance'

const swrFetcher = (url) => pureInstance.get(url).then((res) => res.data)

const caughtPromise = (promise, errorExt) => {
  return promise
    .then((data) => {
      return [null, data]
    })
    .catch((error) => {
      if (errorExt) {
        const parsedError = Object.assign({}, error, errorExt)
        return [parsedError, undefined]
      }

      return [error, undefined]
    })
}

export { pureInstance as pureAxios, swrFetcher, caughtPromise }
export default defaultInstance
